import { costsReducer } from '@cobliteam/costs';
import { deviceConfigurationReducer } from '@cobliteam/device-configuration';
import { pastMaintenancesReducer, registerMaintenanceReducer, upcomingMaintenancesReducer } from '@cobliteam/maintenance';
import { routingReducer as newRoutingReducer, routesReducer } from '@cobliteam/routing/src/store';
import { routeHistoryReducer, trackingReducer } from '@cobliteam/tracking';
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { alarmsReducer } from './Alarms';
import { devicesReducer } from './Devices';
import { disablerReducer } from './Disabler';
import { driversReducer } from './Drivers';
import { fleetReducer } from './Fleet';
import { geocodeReducer } from './Geocode';
import { geofenceFormReducer } from './GeofenceForm';
import { geofenceTabReducer } from './Geofences';
import { geofencesTabReducer } from './GeofenceTab';
import { spreadsheetReducer } from './HOR';
import { history } from './history';
import { invitesReducer } from './Invites';
import { loginReducer } from './Login';
import { mapReducer } from './Map';
import { passwordReducer } from './Password';
import { reportsReducer } from './Performance';
import { popupReducer } from './Popup';
import { usersReducer } from './Users';
import { vehiclePopupReducer } from './VehiclePopup';
import { vehiclesReducer } from './Vehicles';
import { vehiclesTabReducer } from './VehiclesTab';

const rootStoreReducer = combineReducers({
  alarms: alarmsReducer,
  costs: costsReducer,
  devices: devicesReducer,
  disabler: disablerReducer,
  drivers: driversReducer,
  fleet: fleetReducer,
  geocode: geocodeReducer,
  geofenceForm: geofenceFormReducer,
  geofences: geofenceTabReducer,
  geofenceTab: geofencesTabReducer,
  invites: invitesReducer,
  login: loginReducer,
  map: mapReducer,
  newRouting: newRoutingReducer,
  password: passwordReducer,
  pastMaintenances: pastMaintenancesReducer,
  popup: popupReducer,
  registerMaintenance: registerMaintenanceReducer,
  reportsPerformance: reportsReducer,
  router: connectRouter(history),
  routes: routesReducer,
  routesHistory: routeHistoryReducer,
  spreadsheet: spreadsheetReducer,
  tracking: trackingReducer,
  upcomingMaintenances: upcomingMaintenancesReducer,
  users: usersReducer,
  vehiclePopup: vehiclePopupReducer,
  vehicles: vehiclesReducer,
  vehiclesTab: vehiclesTabReducer,
  deviceConfiguration: deviceConfigurationReducer,
});

export { rootStoreReducer };
